import NavigationLinksApi from '../../core/api/NavigationLinksApi'
export const events = {
  fetching: {
    navigationLinks: 'FETCHING_NAVIGATION_LINKS'
  },
  fetched: {
    navigationLinks: 'FETCHED_NAVIGATION_LINKS'
  },
  sidebar: {
    set: {
      open: 'NAVIGATION_LINKS_SIDEBAR_OPEN',
      activeMenu: 'NAVIGATION_LINKS_SIDEBAR_ACTIVE_MENU'
    }
  },
  header: {
    mainMenu: {
      dropdown: {
        enter: 'NAVIGATION_LINKS_MAIN_MENU_DROPDOWN_MOUSE_ENTER',
        leave: 'NAVIGATION_LINKS_MAIN_MENU_DROPDOWN_MOUSE_LEAVE',
        click: 'NAVIGATION_LINKS_MAIN_MENU_DROPDOWN_MOUSE_CLICK'
      }
    }
  }
}

const api = new NavigationLinksApi()

export const actions = {
  on: {
    mouse: {
      enter: (menuName) => ({
        type: events.header.mainMenu.dropdown.enter,
        menuName
      }),
      leave: (menuName) => ({
        type: events.header.mainMenu.dropdown.leave,
        menuName
      }),
      click: (menuName) => ({
        type: events.header.mainMenu.dropdown.click,
        menuName
      })
    }
  },
  set: {
    sidebarOpen: (open) => ({
      type: events.sidebar.set.open,
      open: open
    }),
    activeMenu: (name) => ({
      type: events.sidebar.set.activeMenu,
      name: name
    })
  },
  get: {
    navigationLinks: function () {
      return async (dispatch) => {
        try {
          const response = await api.getNavigationLinks()
          dispatch({
            type: events.fetched.navigationLinks,
            payload: response
          })
          return response
        } catch (error) {
          dispatch({
            type: events.fetched.navigationLinks,
            error: error.toString()
          })
          throw error
        }
      }
    }
  }
}
